import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'shared/components';

const propTypes = {
  languages: PropTypes.array.isRequired,
  currentLanguage: PropTypes.object.isRequired,
  size: PropTypes.string,
  withMenuOverlay: PropTypes.bool,
  selectLanguage: PropTypes.func.isRequired,
};

const defaultProps = {
  size: 'small',
  withMenuOverlay: false,
};

const LanguageSelector = ({
    languages,
    currentLanguage,
    selectLanguage,
    size,
    withMenuOverlay,
  }) => (
    <Select
      ariaLabel={{ id: 'LanguageSelectionDropdown.TitelAttribute', defaultMessage: '** Select language' }}
      testId="language-selector"
      selectedItem={ currentLanguage }
      items={ languages }
      placeholder={{
        id: 'LanguagePicker.dropdown.SelectLanguage.Label',
        defaultMessage: '** Select Language',
      }}
      iconName="globe"
      size={ size }
      clearable={ false }
      onChange={ (item) => selectLanguage(item ? item.key : null) }
      overlay={ withMenuOverlay }
    />
);

LanguageSelector.propTypes = propTypes;
LanguageSelector.defaultProps = defaultProps;

export default LanguageSelector;
